module.exports = __webpack_public_path__ + "static/img/62.c0c207c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/62.png
// module id = D+J4
// module chunks = 1